import React from 'react';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { GOOGLE_API_STREET_VIEW_PATH } from 'Components/utils/google/google.constants';
import { getStaticMapURL } from 'Components/utils/google/google.utils';
import { Map } from 'Components/frameworks/map/Map';
import { StreetView } from 'Components/frameworks/map/StreetView';
type Props = {
  className?: string;
  closeLabel?: string;
  fov?: number;
  heading?: number;
  height?: number;
  latitude: number;
  longitude: number;
  title?: string;
  width?: number;
};
export const GoogleStreetView = ({
  className,
  closeLabel,
  fov = 2,
  heading = 2,
  height = 120,
  latitude,
  longitude,
  title,
  width = 640,
}: Props) => {
  const track = useTracking();
  const staticMapOptions = {
    size: `${width}x${height}`,
    location: `${latitude},${longitude}`,
    fov,
    heading,
    pitch: 0, // guess what, the pitch that gets returned from the API is all kinds of wrong
    // because it really likes looking at ceilings; people don't want to look at
    // ceilings, so we hardcode the pitch to 0 until the API gets its act together
    // and returns 0; tbh we shouldn't even need the API to provide this to us.
  };
  return (
    <Map
      className={className}
      closeLabel={closeLabel}
      dataTestId="streetview-preview"
      imageSrc={getStaticMapURL(GOOGLE_API_STREET_VIEW_PATH, staticMapOptions)}
      onClick={() =>
        track({
          categoryGA: 'resort',
          actionGA: 'mapClick',
          labelGA: 'GoogleStreetView',
        })
      }
      ratio={{
        w: width,
        h: height,
      }}
      title={title}
    >
      <StreetView fov={fov} heading={heading} latitude={latitude} longitude={longitude} />
    </Map>
  );
};
